var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M14.0916 6.36364V18H11.6314V8.69886H11.5632L8.89844 10.3693V8.1875L11.7791 6.36364H14.0916Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }